import axios from 'axios'

import { IMcpSession } from './lucaMcp'

// The business-owned profile ("what this business is") lives in the support-agent backend, just
// like the Luca MCP connectors. We call it directly with the same minted agent-session JWT the
// chat widget uses. Business-scoped: the backend keys it by business_slug from the token.
const SUPPORT_AGENT_ORIGIN = import.meta.env.VITE_SUPPORT_AGENT_API_ORIGIN

export interface IBusinessProfile {
  description: string
  updated_at: string | null
  updated_by_user_id: string | null
}

const client = axios.create({ baseURL: SUPPORT_AGENT_ORIGIN })

const authConfig = ({ token, country }: IMcpSession) => ({
  headers: {
    Authorization: `Bearer ${token ?? ''}`,
    'X-Origin': (country || 'FI').toUpperCase()
  }
})

// The business-profile feature always ships enabled on the backend, but a 404 (e.g. an older
// backend) should still degrade to an empty profile rather than surfacing an error.
const readConfig = (session: IMcpSession) => ({
  ...authConfig(session),
  validateStatus: (status: number) => status === 200 || status === 404
})

const EMPTY_PROFILE: IBusinessProfile = {
  description: '',
  updated_at: null,
  updated_by_user_id: null
}

export const fetchBusinessProfile = async (session: IMcpSession): Promise<IBusinessProfile> => {
  const { data, status } = await client.get('/v1/business-profile', readConfig(session))
  return status === 404 ? EMPTY_PROFILE : data
}

export const updateBusinessProfile = async (
  session: IMcpSession,
  description: string
): Promise<IBusinessProfile> => {
  const { data } = await client.put('/v1/business-profile', { description }, authConfig(session))
  return data
}
